<p-panel
  *ngIf="toDisplayDriverNotes()"
  styleClass="panel-shadow"
  class="driver-notes"
  [class.ghost]="loadingTask"
  [style]="{ 'margin-top': '1em' }"
>
  <p-header>
    <div class="panel-header">Driver Notes</div>
  </p-header>

  <div class="flex">
    <div class="flex-grow-1">
      <div>
        <div style="font-weight: 700; font-size: 14px">Pick-up</div>
      </div>
    </div>
    <div
      class="flex-shrink-1"
      (click)="setChangePickupDialog(true)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      <span class="link-style cursor-pointer">edit</span>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.pickupForename || selectedTask?.pickupSurname">
    <div class="grid-label-value">
      <div>Contact:</div>
      <div class="value ghost-fill">
        {{ selectedTask?.pickupForename }} {{ selectedTask?.pickupSurname }}
      </div>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.pickupEmail && organisationTypeId != 3">
    <div class="grid-label-value">
      <div>Email:</div>
      <div class="value ghost-fill" style="overflow-x: hidden">
        <a href="mailto:{{ selectedTask?.pickupEmail }}">{{ selectedTask?.pickupEmail }}</a>
      </div>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.pickupSecondaryEmail && organisationTypeId != 3">
    <div class="grid-label-value">
      <div>Secondary Email:</div>
      <div class="value ghost-fill" style="overflow-x: hidden">
        <a href="mailto:{{ selectedTask?.pickupSecondaryEmail }}">{{
          selectedTask?.pickupSecondaryEmail
        }}</a>
      </div>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.pickupPhone1 || selectedTask?.pickupPhone2">
    <div class="grid-label-value">
      <div>Phone:</div>
      <div class="value ghost-fill">
        <a href="tel:{{ selectedTask?.pickupPhone1 }}">{{ selectedTask?.pickupPhone1 }}</a>
        <span *ngIf="selectedTask?.pickupPhone1 && selectedTask?.pickupPhone2"> or </span>
        <a href="tel:{{ selectedTask?.pickupPhone2 }}">{{ selectedTask?.pickupPhone2 }}</a>
      </div>
    </div>
  </div>
  <div class="flex align-items-center justify-content-between">
    <div class="grid-label-value">
      <div>Notes:</div>
    </div>
    <div
      class="flex-shrink-1 link-style cursor-pointer"
      (click)="showAddDriverNotes(true)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      + add
    </div>
  </div>

  <div
    class="note note-inner"
    *ngFor="let note of getNotes(selectedTask?.notes, true); let i = index"
    style="width: 100%; word-wrap: break-word"
  >
    <div class="description">
      {{ note.description }}
    </div>
    <div
      class="flex-shrink-1 link-style cursor-pointer"
      (click)="showEditDriverNote(note)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      edit
    </div>
    <div
      class="flex-shrink-1 link-style cursor-pointer"
      (click)="removeDriverNote(note.id)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      remove
    </div>
  </div>

  <div style="display: flex; border-top: 1px solid #dfdfdf; margin-top: 10px; padding-top: 10px">
    <div class="note-header flex-grow-1">
      <div>
        <div style="font-weight: 700; font-size: 14px">Drop-off</div>
      </div>
    </div>
    <div
      class="flex-shrink-1"
      (click)="setChangeDropoffDialog(true)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      <span class="link-style cursor-pointer">edit</span>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.dropoffForename || selectedTask?.dropoffSurname">
    <div class="grid-label-value">
      <div>Contact:</div>
      <div class="value ghost-fill">
        {{ selectedTask?.dropoffForename }} {{ selectedTask?.dropoffSurname }}
      </div>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.dropoffEmail && organisationTypeId != 3">
    <div class="grid-label-value">
      <div>Email:</div>
      <div class="value ghost-fill" style="overflow-x: hidden">
        <a href="mailto:{{ selectedTask?.dropoffEmail }}">{{ selectedTask?.dropoffEmail }}</a>
      </div>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.dropoffSecondaryEmail && organisationTypeId != 3">
    <div class="grid-label-value">
      <div>Secondary Email:</div>
      <div class="value ghost-fill" style="overflow-x: hidden">
        <a href="mailto:{{ selectedTask?.dropoffSecondaryEmail }}">{{
          selectedTask?.dropoffSecondaryEmail
        }}</a>
      </div>
    </div>
  </div>

  <div class="" *ngIf="selectedTask?.dropoffPhone1 || selectedTask?.dropoffPhone2">
    <div class="grid-label-value">
      <div>Phone:</div>
      <div class="value ghost-fill">
        <a href="tel:{{ selectedTask?.dropoffPhone1 }}">{{ selectedTask?.dropoffPhone1 }}</a>
        <span *ngIf="selectedTask?.dropoffPhone1 && selectedTask?.dropoffPhone2"> or </span>
        <a href="tel:{{ selectedTask?.dropoffPhone2 }}">{{ selectedTask?.dropoffPhone2 }}</a>
      </div>
    </div>
  </div>
  <div class="flex align-items-center justify-content-between">
    <div class="grid-label-value">
      <div>Notes:</div>
    </div>
    <div
      class="flex-shrink-1 link-style cursor-pointer"
      (click)="showAddDriverNotes(false)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      + add
    </div>
  </div>
  <div
    class="note"
    *ngFor="let note of getNotes(selectedTask?.notes, false); let i = index"
    style="width: 100%; word-wrap: break-word"
  >
    <div class="description">
      {{ note.description }}
    </div>
    <div
      class="flex-shrink-1 link-style cursor-pointer"
      (click)="showEditDriverNote(note)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      edit
    </div>
    <div
      class="flex-shrink-1 link-style cursor-pointer"
      (click)="removeDriverNote(note.id)"
      *ngIf="
        !commonService.isJobCompleted(job) && organisationTypeId != OrganisationTypeEnum.Supplier
      "
    >
      remove
    </div>
  </div>
</p-panel>

<edit-driver-notes-dialog
  [(visible)]="pickupContactEdit"
  [selectedTask]="selectedTask"
  [isPickup]="true"
  (onSave)="this.onSaveContactDetails($event, true)"
></edit-driver-notes-dialog>

<edit-driver-notes-dialog
  [(visible)]="dropoffContactEdit"
  [selectedTask]="selectedTask"
  [isPickup]="false"
  (onSave)="this.onSaveContactDetails($event, false)"
></edit-driver-notes-dialog>

<p-dialog
  header="Add Driver Note"
  [(visible)]="isShowAddDriverNotes"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div class="style2023 p-3">
    <div class="input-group">
      <div class="input-group-prepend white-space-nowrap">Note Type</div>
      <div class="input-group-item">
        <p-dropdown
          [options]="noteTypes"
          class="dropdown-filter"
          [(ngModel)]="newNoteIsPickup"
        ></p-dropdown>
      </div>
    </div>

    <div class="input-group mt-3">
      <div class="input-group-item pt-2">
        <textarea
          pInputTextarea
          placeHolder="Add Note.."
          class="no-border"
          [(ngModel)]="newNoteDescription"
          [maxlength]="250"
          style="width: 100%; height: 50px"
        ></textarea>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="closeAddDriverNotes()"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        (click)="saveAddDriverNotes()"
        [disabled]="newNoteDescription?.trim().length == 0"
      ></button>
    </div>
  </p-footer>

  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusyAddDriverNotes"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 10%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</p-dialog>

<p-dialog
  header="Edit Driver Note"
  [(visible)]="showEditDriverNoteDialog"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div class="style2023 p-3" *ngIf="driverNoteToEdit">
    <div class="input-group mt-3">
      <div class="input-group-item pt-2">
        <textarea
          pInputTextarea
          placeHolder="Add Note.."
          class="no-border"
          [(ngModel)]="driverNoteToEdit.description"
          [maxlength]="250"
          style="width: 100%; height: 50px"
        ></textarea>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="showEditDriverNoteDialog = false"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        (click)="saveDriverNote()"
        [disabled]="driverNoteToEdit && driverNoteToEdit.description?.trim().length == 0"
      ></button>
    </div>
  </p-footer>

  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusyAddDriverNotes"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 10%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</p-dialog>
